import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export default function ConfirmationPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const { bookingDetails, start_time, end_time } = location.state || {};

  // Если это подтверждение отзыва
  if (type === 'review') {
    return (
      <main className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 max-w-lg w-full text-center">
          <div className="text-primary mb-4">
            <svg
              className="mx-auto w-16 h-16"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Спасибо за отзыв!</h1>
          <p className="text-gray-600 mb-6">Ваш отзыв успешно добавлен</p>
          <button 
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-secondary text-white rounded-md hover:bg-secondary/90 transition"
          >
            Вернуться на главную
          </button>
        </div>
      </main>
    );
  }

  // Если это подтверждение записи
  if (!bookingDetails) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 max-w-lg w-full text-center">
          <div className="text-red-500 mb-4">
            <svg
              className="mx-auto w-16 h-16"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Ошибка</h1>
          <p className="text-gray-600 mb-6">Не удалось загрузить детали записи</p>
          <button
            onClick={() => navigate('/')}
            className="inline-block px-6 py-3 bg-secondary text-white rounded-md font-semibold hover:bg-secondary/90 transition"
          >
            Вернуться на главную
          </button>
        </div>
      </div>
    );
  }

  const formattedDate = new Date(start_time).toLocaleString('ru-RU', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit'
  });

  const formattedTime = new Date(end_time).toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <main className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-10">
      <div className="bg-white rounded-2xl shadow-lg p-6 max-w-lg w-full text-center">
        <div className="text-primary mb-4">
          <svg
            className="mx-auto w-16 h-16"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Запись подтверждена!</h1>
        <p className="text-gray-600 mb-6">Мы отправили детали записи на ваш телефон</p>

        <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
          <h2 className="font-semibold mb-3">Детали записи:</h2>
          <ul className="space-y-2 text-sm">
            <li className="flex justify-between">
              <span className="text-gray-500">Клиника:</span>
              <span className="font-medium">{bookingDetails.clinic_name}</span>
            </li>
            <li className="flex justify-between">
              <span className="text-gray-500">Услуга:</span>
              <span className="font-medium">{bookingDetails.service_name}</span>
            </li>
            <li className="flex justify-between">
              <span className="text-gray-500">Специалист:</span>
              <span className="font-medium text-right">{bookingDetails.specialist_name}</span>
            </li>
            <li className="flex justify-between">
              <span className="text-gray-500">Дата и время:</span>
              <span className="font-medium text-right">{formattedDate} – {formattedTime}</span>
            </li>
          </ul>
        </div>

        <button 
          onClick={() => navigate('/')}
          className="mt-6 px-4 py-2 bg-secondary text-white rounded-md hover:bg-secondary/90 transition"
        >
          Вернуться на главную
        </button>
      </div>
    </main>
  );
}
